import React from "react";
import { useIntl } from "react-intl";
import { Row, Col, Typography } from "antd";

const { Text } = Typography;

const ClientContainer = ({ children }) => {
  const intl = useIntl();
  return (
    <Row type="flex" justify="center" className="clients-choice-container">
      <Col>
        <Row type="flex">
          <Col>
            <Text>
              {intl.formatMessage({
                id: "user.client.choose",
                defaultMessage: "Vyberte klienta, za kterého chcete pracovat",
              })}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col>{children}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ClientContainer;
